import $ from 'cash-dom'

$(document).ready(function () {
  const $select = $('.js-c-select-status')
  const form = document.getElementById('status-change-form')
  $select.on('change', () => form.submit())
})
